import React, { useEffect, useState } from "react";
import Product from "./product/ProductSelects";
import { Modal, Tag, Row } from "antd";
import { PlusOutlined } from "@ant-design/icons";

const confirm = Modal.confirm;

const ProductSelects = ({ productItems, onSelectProducts }) => {
  const [show, setShow] = useState(false);
  const [products, setProducts] = useState([]);
  const [productSelects, setProductSelects] = useState(productItems);

  useEffect(() => {
    if (productItems.length > 0) {
      setProductSelects(productItems);
    }
  }, [productItems]);

  const onSelected = (data) => {
    setProducts(data);
  };
  const showWindow = () => {
    setShow(!show);
  };

  const onOkModal = () => {
    if (products.length === 0) {
      confirm({
        title: "Lưu ý .Bạn chưa chọn sản phẩm!?",
        cancelText: "Hủy",
        okText: "Tiếp tục",
        onOk() {
          setProductSelects(products);
          setShow(!show);
        },
        onCancel() {},
      });
    } else {
      setShow(!show);
      setProductSelects(products);
      onSelectProducts(products);
    }
  };

  const forMap = (tag) => {
    const tagElem = (
      <Tag className="my-tag" color="#87d068">
        {tag.name}
      </Tag>
    );
    return (
      <span
        key={tag.id}
        style={{
          display: "inline-block",
        }}
      >
        {tagElem}
      </span>
    );
  };

  const tagChild = productSelects.map(forMap);

  return (
    <>
      <div>
        <div>
          <Row>
            {tagChild}

            <Tag
              className="my-tag"
              onClick={showWindow}
              style={{ cursor: "pointer" }}
            >
              Chọn sản phẩm <PlusOutlined />
            </Tag>
          </Row>
        </div>

        {show && (
          <Modal
            title=""
            visible={show}
            width={1300}
            onOk={() => {
              onOkModal();
            }}
            style={{ top: 20 }}
            // okButtonProps={{
            //   disabled: !products,
            // }}
            onCancel={() => {
              setShow(false);
            }}
            destroyOnClose={true}
          >
            <div style={{ padding: "15px" }} className="ant-table-content">
              <Product onSelected={onSelected} products={productSelects} />
            </div>
          </Modal>
        )}
      </div>
    </>
  );
};

export default ProductSelects;
